jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.news-posts').length ) {

        let $ = jQuery;
        const $container = $(".js-news-wrapper");
        const $loadMoreBtn = $("#load-more-news");
        const $catFilter = $("#category_select");
        const $monthFilter = $("#month_select");
        const $yearFilter = $("#year_select");

        $catFilter.on("change", function() {
            $container.attr('data-cat_id', $(this).val());
            $container.attr('data-page', '0');
            $container.empty();
            loadResults();
        });

        $monthFilter.on("change", function() {
            $container.attr('data-month', $(this).val());
            $container.attr('data-page', '0');
            $container.empty();
            if($yearFilter.val() != '') {
                loadResults();
            }
        });
        $yearFilter.on("change", function() {
            $container.attr('data-year', $(this).val());
            $container.attr('data-page', '0');
            $container.empty();
            if($monthFilter.val() != '') {
                loadResults();
            }
        });


        $loadMoreBtn.on("click", function () {
            loadResults();
        });
        


        function loadResults() {

            $currentPage = $container.attr('data-page');
            $perPage = $container.attr('data-posts_per_page');
            $exclude = $container.attr('data-exclude');
            $category = $container.attr('data-cat_id');
            $month = $container.attr('data-month');
            $year = $container.attr('data-year');

            // console.log("Current Page: " + $currentPage)

            var sendData = {
                action: 'news_ajax_handler',
                page: $currentPage,
                perPage: $perPage,
                exclude: $exclude,
                category: $category,
                month: $month,
                year: $year
            };

            $.ajax({
                url: ajaxadminurl.ajaxurl,
                type: 'GET',
                data: sendData,
                dataType: 'html',
                cache: false,
                timeout: 10000,
                beforeSend: function() {
                    $loadMoreBtn.hide();
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    $loadMoreBtn.remove();
                },
                success: function(data, textStatus, jqXHR) {
                    var htmlData = $.parseHTML(jqXHR.responseText);
                    $container.append(htmlData);
                    $container.attr('data-page', parseInt($currentPage) + 1);
                    // console.log("Updating Page: " + (parseInt($currentPage) + 1));
                },
                complete: function(data) {
                    if (data.responseText !== '<div class="nothing-found"><h4>No results found</h3></div>') {
                        checkNextPosts(parseInt($currentPage) + 1);
                        // console.log("checking next posts for " + (parseInt($currentPage) + 1));
                    }
                    AOS.init();
                }
            });
        }

        function checkNextPosts($page) {

            var sendData = {
                action: 'news_ajax_handler',
                page: $page,
                perPage: $perPage,
                exclude: $exclude,
                category: $exclude,
                month: $month,
                year: $year
            };

            $.ajax({
                url: ajaxadminurl.ajaxurl,
                type: 'GET',
                data: sendData,
                dataType: 'html',
                cache: false,
                timeout: 10000,
                success: function(data, textStatus, jqXHR) {
                    if (data.responseText !== '<div class="nothing-found"><h4>No results found</h3></div>') {
                        $loadMoreBtn.show();
                    }
                },
                complete: function(data) {
                    if (data.responseText !== '<div class="nothing-found"><h4>No results found</h3></div>') {
                        $loadMoreBtn.show();
                    }
                }
            });
        }

    }
});